import { alpha, Box, Grid, styled } from '@mui/material';

export const SearchFormsContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(4, 1, 1),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,

  [theme.breakpoints.up('md')]: {
    border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
    marginTop: theme.spacing(3.5),
    padding: theme.spacing(3, 2),
  },
}));

export const ReportContainer = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(1),
  margin: theme.spacing(1),
  width: '100%',
  backgroundColor: theme.palette.background.paper,

  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(0, 2, 2),
    margin: 0,
    marginTop: theme.spacing(2),
  },
}));

export const DetailsContainer = styled(Box)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,

  [theme.breakpoints.up('md')]: {
    marginTop: theme.spacing(2.5),
    padding: theme.spacing(2, 2, 0),
    border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
  },
}));

export const InformationCardContainer = styled(Box)(({ theme }) => ({
  marginInline: theme.spacing(1),
  [theme.breakpoints.up('md')]: {
    margin: 0,
    marginLeft: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
}));
